<template>
  <vjs-modal v-bind="$options.propsData"
             icon="la la-exclamation-circle"
             :title="title"
             width="500">
    <template slot="body-content">
      <div class="form-group">
        <label for="pwd-input">
          Please re-enter your password to continue:
        </label>
        <input v-model="pass" class="form-control"
               type="password"
               name="pwd-input">
      </div>
      <div v-if="awaiting_confirm" class="password-confirm-awaiting">
        <b-spinner label="Waiting for confirmation..." />
      </div>
    </template>
    <template slot="body-controls">
      <b-button variant="ss-standout" :disabled="awaiting_confirm" @click="() => close(true)">
        Confirm
      </b-button>
      <b-button variant="ss-cancel" @click="() => close(false)">
        Cancel
      </b-button>
    </template>
  </vjs-modal>
</template>

<script>
import VjsModal from 'VueModals/VjsModal';
import VjsModalMixin from 'VueModals/VjsModalMixin';

export default {
  name: `password-confirm-modal`,
  components: {
    VjsModal,
  },
  mixins: [VjsModalMixin],
  props: {
    title: {
      type: String,
      required: false,
      default: `Confirm Password`,
    },
  },
  data: () => ({
    pass: null,
    awaiting_confirm: false,
  }),
  methods: {
    async close(confirm) {
      this.awaiting_confirm = true;
      this.close_data.success = false;
      this.close_data.password = this.pass;
      try {
        if (confirm) {
          await axios.post(`/api/v1/user/confirm-password`, {
            password: this.pass,
          });
          this.close_data.success = true;
        }
      } catch (err) {
        window.handleAxiosError(err);
      } finally {
        this.awaiting_confirm = false;
        this.close_data.confirm = confirm;
        this.complete();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.password-confirm-awaiting {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 1em 0;
}
</style>
